/**
 * O mãos livres está em uso agora.
 *
 * Existe para o resto do app saber que não pode aparecer por cima da leitura:
 * no mãos livres o operador está olhando a fila, não a tela, e o aparelho fica
 * apontado para os ingressos. Um aviso ali — como o de versão nova — roubaria
 * espaço da faixa de desfecho e convidaria a um toque que ninguém quis dar.
 *
 * Quem liga e desliga é a tela do validador; quem consulta, por enquanto, é o
 * `AvisoAtualizacao`. O estado que manda continua sendo o do caixa
 * (`definirMaosLivres`, em src/caixa.ts) — isto aqui é só o reflexo dele na
 * tela, para os avisos se comportarem.
 */

import {useEffect, useState} from 'react';

let emUso = false;
const ouvintes = new Set<() => void>();

export function marcarMaosLivres(ligado: boolean): void {
  if (emUso === ligado) {
    return;
  }
  emUso = ligado;
  ouvintes.forEach(avisar => avisar());
}

export function useMaosLivresEmUso(): boolean {
  const [, setVersao] = useState(0);

  useEffect(() => {
    const ouvinte = () => setVersao(v => v + 1);
    ouvintes.add(ouvinte);
    return () => {
      ouvintes.delete(ouvinte);
    };
  }, []);

  return emUso;
}
